import { addressToString } from '@aloft/toolkit-shared';
import { Block, Button, Flex, Typography } from '@aloft/toolkit-sui';

import { StripeAddressElementValue } from './types.ts';
import { useCheckoutSteps } from './useCheckoutSteps.ts';

type Props = {
  address: StripeAddressElementValue;
};

export function BillingAddressPreview({ address: passedAddress }: Props) {
  const { prevStep } = useCheckoutSteps();

  const handleEditClick = () => {
    prevStep();
  };

  const { name, address } = passedAddress;
  const addressString = addressToString({
    AddressLineText: address.line1,
    unitNumber: address.line2 ?? undefined,
    CityName: address.city,
    StateCode: address.state,
    PostalCode: address.postal_code,
  });

  return (
    <Flex
      border="1px solid"
      borderColor="strokeDefault"
      borderRadius="4px"
      paddingY="6px"
      paddingX="8px"
    >
      <Block flexGrow={1}>
        <Typography>{name}</Typography>
        <Typography>{addressString}</Typography>
      </Block>
      <Block flexGrow={0}>
        <Button size="sm" text="Edit" variant="inline" onClick={handleEditClick} />
      </Block>
    </Flex>
  );
}
